import React from 'react'
import { UseFormRegister, UseFormWatch } from 'react-hook-form'
import { formatCurrency, calculateMonthlyRent, calculateProratedTotal, getNextFirstOfMonth } from '../../../../utils'
import { StorageFormValues } from '../config/validationSchema'

interface PricingSummaryStepProps {
  register: UseFormRegister<StorageFormValues>
  watch: UseFormWatch<StorageFormValues>
  space: any
}

const PricingSummaryStep: React.FC<PricingSummaryStepProps> = ({
  register,
  watch,
  space
}) => {
  const need24hrAccess = watch('need_24hr_access')
  const need3xWeekAccess = watch('need_3x_week_access')
  const agreeToPolicy = watch('agree_to_privacy_policy')

  return (
    <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
      <div className="forceBlack" style={{ fontSize: '1rem', marginBottom: '2rem' }}>
        <div style={{ marginBottom: '1rem' }}>
          <strong>Total Due Today:</strong> ${formatCurrency(calculateMonthlyRent(space?.monthly_rate, need24hrAccess, need3xWeekAccess) + calculateProratedTotal(space?.monthly_rate, need24hrAccess, need3xWeekAccess))}
          <div style={{ marginLeft: '1.2rem' }}>
            (Includes prorated rent plus a one-month security deposit)
          </div>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <strong>Security Deposit:</strong> ${formatCurrency(calculateMonthlyRent(space?.monthly_rate, need24hrAccess, need3xWeekAccess))}
          <div style={{ marginLeft: '1.2rem' }}>
            Fully refundable with a 30-day cancellation notice sent by email to <span style={{ fontStyle: 'italic', textDecoration: 'underline' }}>hello@gahannarvandboat.com</span>
          </div>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <strong>Monthly Rent:</strong> ${formatCurrency(calculateMonthlyRent(space?.monthly_rate, need24hrAccess, need3xWeekAccess))}
          <div style={{ marginLeft: '1.2rem' }}>
            Automated recurring payments begin {getNextFirstOfMonth()}
          </div>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <strong>Payment Method:</strong>
          <div style={{ marginLeft: '1.2rem' }}>
            The payment method used today will be applied to future recurring payments. Additional payment methods can be requested if needed.
          </div>
        </div>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <input
            className="checkbox"
            id="agree_to_privacy_policy"
            type="checkbox"
            {...register('agree_to_privacy_policy')}
          />
          <label className="checkboxLabel forceBlack" style={{ fontSize: '1rem', fontWeight: 'normal' }}>
            I have read and understood the above and agree to
            &nbsp;<a
              href="/privacy-policy.html"
              target="_blank"
              className="forceBlack underline"
              rel="noopener noreferrer"
              style={{ fontWeight: 'bold' }}
            >Gahanna RV & Boat Storage's Privacy Policy</a>
          </label>
        </div>
        {!agreeToPolicy && <div className="input-feedback">You must agree to the privacy policy</div>}
      </div>
    </div>
  )
}

export default PricingSummaryStep
